export default __webpack_public_path__ + "static/media/bars-menu.b428e1b0.svg";